
// Global Variables
const desktop = window.matchMedia("(min-width: 1281px)");
const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

module.exports = { desktop, scrollElement }
